import isAssetMgmt from '../is/assetMgmt/routerPaths';
import isFm from '../is/fm/routerPaths';
import isHeatMonitoring from '../is/heatMonitoring/routerPaths';

const linksMixin = {
  data() {
    return {
      links: [
        {
          category: 'Common.drawer.applications',
        },
        {
          to: '/home',
          icon: 'fal fa-stars',
          text: 'Common.drawer.home',
        },
        {
          to: '/digitaltwin-mgmt',
          icon: 'fal fa-dice-d8',
          text: 'Common.drawer.dTwins',
          dataCy: 'drawer_dtwins',
        },
        {
          to: '/digitaltwin/rules-monitor',
          icon: 'fal fa-monitor-heart-rate',
          text: 'Common.drawer.dTwinRulesMonitor',
          featureflag: 'rd-6423-show-rule-exec-monitor',
        },
        {
          to: 'GRAFANA_PLACEHOLDER',
          icon: 'fal fa-chart-line',
          text: 'Common.drawer.grafana',
          permissions: {
            or: [
              { subject: 'IotHub', action: 'read' },
              { subject: 'DigitalTwin', action: 'read' },
              { subject: 'VirtualDevice', action: 'read' },
            ],
          },
        },
        {
          to: '/digitaltwin-state-overview',
          icon: 'fal fa-tachometer-alt-fast',
          text: 'Common.drawer.dTwinStateOverview',
          permissions: {
            or: [
              { subject: 'DigitalTwinStates', action: 'read' },
              { subject: 'DigitalTwin', action: 'read' },
            ],
          },
        },
        {
          icon: 'fal fa-puzzle-piece',
          text: 'Common.drawer.accountMgmtModules',
          children: [
            {
              icon: 'fal fa-sensor-fire',
              text: 'IS.Warnapp.drawer.isWarnapp',
              permissions: {
                or: [
                  { subject: 'IsWarnapp', action: 'manage' },
                  { subject: 'IsWarnapp', action: 'read' },
                ],
              },
              children: [
                {
                  to: '/is-warnapp-viewer',
                  icon: 'fal fa-siren-on',
                  text: 'IS.Warnapp.drawer.isWarnappViewer',
                },
                {
                  to: '/is-warnapp-admin',
                  icon: 'fal fa-sliders-h',
                  text: 'IS.Warnapp.drawer.isWarnappAdmin',
                },
              ],
            },
            ...isAssetMgmt.drawerLinks,
            ...isFm.drawerLinks,
            ...isHeatMonitoring.drawerLinks,
          ],
        },
        {
          category: 'Common.drawer.connectivity',
        },
        {
          icon: 'fal fa-sensor-on',
          text: 'Common.drawer.deviceManagement',
          children: [
            {
              to: '/virtual-devices',
              icon: 'fal fa-sensor-on',
              text: 'Common.drawer.virtualDevices',
            },
            {
              to: '/virtual-device-groups',
              icon: 'fal fa-object-group',
              text: 'Common.drawer.monitoringViews',
              permissions: {
                or: [{ subject: 'VirtualDevice', action: 'read' }],
              },
            },
            {
              to: '/niota-classic/device-types',
              icon: 'fal fa-cubes',
              text: 'NiotaClassic.DeviceTypes.title',
              featureflag: 'env_dispatcher_devicetype_fallback',
              permissions: {
                or: [
                  { subject: 'VirtualDevice', action: 'manage' },
                  { subject: 'VirtualDevice', action: 'read' },
                ],
              },
            },
            {
              to: '/virtual-device-drivers',
              icon: 'fal fa-sensor-smoke',
              text: 'Common.drawer.virtualDeviceDrivers',
              featureflag: '!env_dispatcher_devicetype_fallback',
              permissions: {
                or: [
                  { subject: 'DeviceDriver', action: 'read' },
                  { subject: 'DeviceDriver', action: 'manage' },
                ],
              },
            },
            {
              to: '/alarm-logs',
              icon: 'fal fa-sensor-alert',
              text: 'Common.drawer.alarmLogs',
            },
            {
              to: '/device-templates',
              icon: 'fal fa-sitemap',
              text: 'Common.drawer.deviceTemplates',
              permissions: {
                or: [
                  { subject: 'DeviceTemplate', action: 'read' },
                  { subject: 'DeviceTemplate', action: 'manage' },
                ],
              },
            },
            {
              to: '/alarm-log-reports',
              icon: 'fal fa-file-exclamation',
              text: 'Common.drawer.alarmReports',
              permissions: {
                or: [{ subject: 'VirtualDevice', action: 'manage' }],
              },
            },
          ],
        },
        {
          icon: 'fal fa-chart-network',
          text: 'Common.drawer.integrations',
          children: [
            {
              to: '/connectors/consumers/list',
              icon: 'fal fa-angle-double-right',
              text: 'Common.drawer.integrationsFlows',
            },
            {
              to: '/connectors/consumers/filters',
              icon: 'fal fa-filter',
              text: 'Common.drawer.consumerFilters',
            },
            {
              to: '/connectors/consumers/transformers',
              icon: 'fal fa-random',
              text: 'Common.drawer.consumerTransformations',
            },
            {
              to: '/connectors/list',
              icon: 'fal fa-plug',
              text: 'Common.drawer.connectors',
            },
          ],
        },
        {
          icon: 'fal fa-server',
          text: 'Common.drawer.iotDataHub',
          featureflag: '!env_hide_iotdatahub',
          children: [
            {
              to: '/niota-classic/applications',
              icon: 'fal fa-laptop',
              text: 'NiotaClassic.Applications.title',
            },
            {
              to: '/niota-classic/consumers',
              icon: 'fal fa-share-alt',
              text: 'NiotaClassic.Consumers.title',
            },
            {
              to: '/niota-classic/devices',
              icon: 'fal fa-sensor-on',
              text: 'NiotaClassic.Devices.title',
            },
            {
              to: '/niota-classic/device-types',
              icon: 'fal fa-cubes',
              text: 'NiotaClassic.DeviceTypes.title',
              permissions: {
                or: [
                  { subject: 'IotHub', action: 'manage' },
                  { subject: 'IotHub', action: 'read' },
                ],
              },
            },
            {
              to: '/niota-classic/gw-mgmt',
              icon: 'fal fa-router',
              text: 'NiotaClassic.GWMonitoring.title',
            },
            {
              to: '/niota-classic/device-monitoring',
              icon: 'fal fa-monitor-heart-rate',
              text: 'NiotaClassic.DeviceMonitoring.title',
            },
            {
              icon: 'fal fa-cloud',
              text: 'Common.drawer.iotDataHubSauces',
              children: [
                {
                  to: '/niota-classic/originators',
                  icon: 'fal fa-cloud-upload',
                  text: 'NiotaClassic.Originators.title',
                },
                {
                  to: '/niota-classic/data-sources',
                  icon: 'fal fa-cloud',
                  text: 'NiotaClassic.DataSources.title',
                },
              ],
            },
          ],
        },
        {
          icon: 'fal fa-project-diagram',
          text: 'Common.drawer.connectedSystems',
          children: [
            {
              to: '/niota-classic/service-builders',
              icon: 'fal fa-project-diagram',
              text: 'Common.drawer.nodeRed',
            },
            {
              to: 'FIREFLY_PLACEHOLDER',
              icon: 'fal fa-broadcast-tower',
              text: 'Common.drawer.lorawan',
              permissions: {
                or: [
                  { subject: 'IotHub', action: 'manage' },
                  { subject: 'IotHub', action: 'read' },
                ],
              },
            },
          ],
        },
        {
          category: 'Common.drawer.administration',
        },
        {
          icon: 'fal fa-cogs',
          text: 'Common.drawer.accountMgmtGroup',
          dataCy: 'drawer_administration',
          children: [
            {
              to: '/account-mgmt',
              icon: 'fal fa-users',
              text: 'Common.drawer.accountMgmt',
              dataCy: 'drawer_account_mgmt',
            },
            {
              to: '/user-profile',
              icon: 'fal fa-user-astronaut',
              text: 'Common.drawer.userProfile',
            },
            {
              to: '/system-settings',
              icon: 'fal fa-tools',
              text: 'Common.drawer.systemsettings',
            },
            {
              to: '/account-mgmt-announcements',
              icon: 'fal fa-bullhorn',
              text: 'Common.drawer.accountMgmtAnnouncement',
            },
            {
              icon: 'fal fa-user-unlock',
              text: 'Common.drawer.accountMgmtPermissionsGroup',
              children: [
                {
                  to: '/account-mgmt-modules',
                  icon: 'fal fa-puzzle-piece',
                  text: 'Common.drawer.accountMgmtModules',
                },
                {
                  to: '/account-mgmt-roles',
                  icon: 'fal fa-user-tag',
                  text: 'Common.drawer.accountMgmtRoleEditor',
                },
              ],
            },
          ],
        },
        {
          to: '/background-jobs',
          icon: 'fal fa-flux-capacitor',
          text: 'Common.drawer.backgroundJobs',
        },
        {
          to: '/system-logs',
          icon: 'fal fa-clipboard-check',
          text: 'Common.drawer.systemLogs',
        },
        {
          to: '/superadmin-terminal',
          icon: 'fal fa-terminal',
          text: 'Common.drawer.systemTerminal',
        },
        // {
        //   to: '/api',
        //   icon: 'fal fa-file-code',
        //   text: 'Common.drawer.api',
        // },
      ],
    };
  },
};

export default linksMixin;
